const getFramework = (countryCode) => {
    let framework;
    switch (countryCode) {
        case "US":
            framework = "usnat";
            break;
        case "AU":
            framework = "aus";
            break;
        case "GB":
        default:
            framework = "tcfv2";
            break;
    }
    return framework;
};
export { getFramework };
